import {BaseService} from './baseService.js';

/**
 * Handles interaction with user grid column layout APIs
 */
export class GridColumnLayoutService extends BaseService {

	constructor() {
		super();
	}

	async getLayoutsForPage(pageKey) {
		var params = '';
		if (pageKey) {
			params = '?pageKey=' + encodeURIComponent(pageKey);
		}
		return this.makeGETRequest('/api/resource/user-grid-column-layouts' + params);
	}

	async saveLayout(layout) {
		return this.makePUTRequest('/api/resource/user-grid-column-layouts', layout);
	}

}
